<template>
  <LoginTemplate>
    <router-link to="/">
      <LogoComponent
        class="mb-2"
        app-variant="pool-live"
      />
    </router-link>
    <slot />
  </LoginTemplate>
</template>

<script>
import LoginTemplate from '@acs/components-library/src/components/template/LoginTemplate.vue';
import LogoComponent from '@acs/components-library/src/components/common/Logo.vue';

export default {
  components: {
    LoginTemplate,
    LogoComponent,
  },
};

</script>
